import React from 'react';
import {
  FirstImpressionsProvider,
  FirstImpressionsContextProps
} from './use-first-impressions-state';
import { FirstImpressionsView } from './first-impressions-view';

export function FirstImpressionsScreen(props: FirstImpressionsContextProps) {
  return (
    <FirstImpressionsProvider {...props}>
      <FirstImpressionsView />
    </FirstImpressionsProvider>
  );
}
